class HeaderDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.querySelector('summary');

    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.addEventListener('click', this.onClick.bind(this));
      this.mainDetailsToggle.addEventListener('keyup', this.onKeyUp.bind(this));
    }
  }

  onClick(event) {
    const target = event.target.closest('summary');
    if (!target) return;

    event.preventDefault();
    const details = target.closest('details');

    if (details.hasAttribute('open')) {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      document.body.classList.remove('overflow-hidden-mobile');
      this.summary.setAttribute('aria-expanded', 'false');
    } else {
      details.setAttribute('open', '');
      details.classList.add('menu-opening');
      document.body.classList.add('overflow-hidden-mobile');
      this.summary.setAttribute('aria-expanded', 'true');
    }
  }

  onKeyUp(event) {
    if (event.code && event.code.toUpperCase() === 'ESCAPE') {
      this.closeMenuDrawer(event);
    }
  }

  closeMenuDrawer(event) {
    if (event) event.preventDefault();
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.classList.remove('menu-opening');
      document.body.classList.remove('overflow-hidden-mobile');
      this.summary.setAttribute('aria-expanded', 'false');
    }
  }
}

customElements.define('header-drawer', HeaderDrawer);

// Cerrar drawer al hacer clic fuera
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('header-drawer').forEach(drawer => {
    const details = drawer.querySelector('details');
    if (!details) return;

    // Cerrar al hacer clic en el overlay
    details.querySelector('summary').addEventListener('click', (e) => {
      const isOpen = details.hasAttribute('open');
      if (isOpen) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        document.body.classList.remove('overflow-hidden-mobile');
      } else {
        details.setAttribute('open', '');
        details.classList.add('menu-opening');
        document.body.classList.add('overflow-hidden-mobile');
      }
    });
  });
});